import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { SERIAL_NUMBER } from '../../../../../filters/constants';
import messages from './messages';

export const serialNumber = {
  id: SERIAL_NUMBER,
  displayName: <FormattedMessage {...messages.serialNumber} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'SerialNumber',
  render: (criteriaInformations: Record<string, unknown>) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
